module.exports = __webpack_public_path__ + "static/media/linkedin-grey.d761fec9.svg";